var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"headline my-7 ml-2"},[_vm._v(" "+_vm._s(_vm.staff)+" ")]),_c('v-card',{staticClass:"my-10",attrs:{"elevation":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }